import { TableCell, TableRow } from '@material-ui/core'
import dateFormat from 'dateformat'
import { TFunction } from 'i18next'
import EmailAlertIcon from 'mdi-react/EmailAlertIcon'
import { Fragment, FC } from 'react'
import {
  SelectApartment,
  RemoveApartment,
  Navigate,
  UpdateStatus,
  UpdateApartmentCode
} from '../../../actions/types'
import { MuiClasses } from '../../../types'
import { Apartment } from '../../../types/apartments'
import { Application } from '../../../types/applications'
import {
  IndexedUsersState
} from '../../../types/states'
import { isUserWithContactInfo } from '../../../types/users'
import {
  getApartmentOwnerEmail,
  getApartmentOwnerPhone
} from '../../../utils/apartments'

import { getApplicationsAmounts } from '../../Applications/values/handleApplicationsData'
import { ApartmentsShowingProps } from '../Apartments'
import ApartmentsTableRowCollapse from './ApartmentsTableRowCollapse'
import ApplicationsCell from './ApplicationsCell'
export interface ApartmentRowProps {
  classes: MuiClasses
  apartment: Apartment
  apartmentApplications: Application[]
  isSelected: boolean
  showingsProps: ApartmentsShowingProps
  t: TFunction
  deselectApartment: () => void
  selectApartment: SelectApartment
  removeApartment: RemoveApartment
  listUsersAction: () => void
  navigate: Navigate
  updateStatus: UpdateStatus
  updateApartmentCode: UpdateApartmentCode
  colSpan: number
  users: IndexedUsersState
}

const ApartmentRow: FC<ApartmentRowProps> = ({
  classes,
  apartment,
  apartmentApplications,
  isSelected,
  t,
  deselectApartment,
  selectApartment,
  listUsersAction,
  removeApartment,
  navigate,
  updateStatus,
  updateApartmentCode,
  colSpan,
  users
}) => {
  const {
    apartmentId,
    createdAt,
    updatedAt,
    applicationsViewedAt,
    statusUpdatedAt,
    confirmation,
    information,
    switchedData,
    code,
    status
  } = apartment
  const apartmentApplicationAmounts = getApplicationsAmounts(
    apartmentApplications || []
  )
  const address = information
    ? `${information.address}, ${information.postalArea}`
    : undefined
  const apartmentUserEmail = getApartmentOwnerEmail(apartment, users)
  const apartmentUserPhone = getApartmentOwnerPhone(apartment, users)
  const apartmentUser = users[apartment.userId]
  const isEmailUnconfirmed =
    isUserWithContactInfo(apartmentUser) && apartmentUser.emailUnconfirmed === true
  const marketingDays =
    status === 'marketing' && statusUpdatedAt
      ? Math.floor((Date.now() - statusUpdatedAt) / (1000 * 60 * 60 * 24))
      : undefined
  const availableFromDate =
    switchedData?.availableFromDate || confirmation?.availableFromDate
  return (
    <Fragment key={apartmentId}>
      <TableRow
        hover
        className={classes.normalRow}
        onClick={() =>
          isSelected
            ? deselectApartment()
            : (listUsersAction(), selectApartment(apartmentId))
        }
        tabIndex={-1}
        key={apartmentId}
        selected={isSelected}
      >
        <TableCell>{t(`adminApartments.statuses.${status}`)}</TableCell>
        <TableCell>{address}</TableCell>

        <ApplicationsCell {...apartmentApplicationAmounts} />
        <TableCell>{confirmation?.price}</TableCell>
        <TableCell style={{ maxWidth: 180, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
          {isEmailUnconfirmed && (
            <span style={{ display: 'inline-flex', color: '#f57c00', marginRight: 4, verticalAlign: 'middle' }}>
              <EmailAlertIcon size={16} />
            </span>
          )}
          {apartmentUserEmail}
        </TableCell>
        <TableCell>
          <a
            style={{ color: 'inherit', textDecoration: 'none' }}
            href={`tel:+${apartmentUserPhone}`}
          >
            +{apartmentUserPhone}
          </a>
        </TableCell>
        <TableCell>{code}</TableCell>
        <TableCell>{dateFormat(createdAt, 'dd.mm.yyyy HH:MM')}</TableCell>
        <TableCell>{dateFormat(updatedAt, 'dd.mm.yyyy HH:MM')}</TableCell>
        <TableCell>
          {applicationsViewedAt
            ? dateFormat(applicationsViewedAt, 'dd.mm.yyyy HH:MM')
            : t('apartments.table.values.unknown')}
        </TableCell>
        <TableCell style={{ width: 100 }}>
          {marketingDays !== undefined ? `${marketingDays} vrk` : '–'}
        </TableCell>
        <TableCell style={{ width: 110 }}>
          {availableFromDate
            ? dateFormat(new Date(availableFromDate), 'dd.mm.yyyy')
            : t('apartment.list.confirmation.availableFromDateNegotiate')}
        </TableCell>
      </TableRow>
      {isSelected && (
        <TableRow className={classes.selectedRow}>
          <TableCell colSpan={colSpan}>
            <ApartmentsTableRowCollapse
              apartment={apartment}
              removeApartment={removeApartment}
              navigate={navigate}
              apartmentApplications={apartmentApplications}
              t={t}
              updateStatus={updateStatus}
              updateApartmentCode={updateApartmentCode}
              isEmailUnconfirmed={isEmailUnconfirmed}
              apartmentOwnerEmail={apartmentUserEmail}
            />
          </TableCell>
        </TableRow>
      )}
    </Fragment>
  )
}

export default ApartmentRow
